import React, { useEffect, useState } from 'react';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import { useParams } from 'react-router-dom';
import { formatCurrency, generateId, shortHandDateTime } from '../../utility/functions';
import Table from '../../table/Table';
import LinkTo from '../../forms/LinkTo';

const Purchases = ({ children, ...props }) => {

    const { guid } = useParams();

    const [data, setData] = useState(null);

    useEffect(() => {
        HamQuest.get(QuestRoute.user.purchases(guid))
            .then(res => {
                setData(res.flatMap(e => e.purchasedProducts.map(f => ({ ...e, ...f }))))
            })
    }, [])

    const tableConfig = {
        label: 'Purchases',
        data: data,
        headers: [
            {
                label: 'Name',
                propKey: 'name',
                options: true,
            }, {
                label: 'Purchase Date',
                propKey: 'purchaseDate',
                type: 'date'
            }, {
                label: 'Amount',
                propKey: 'total',
                type: 'number'
            }, {
                label: 'Is a Gift',
                propKey: 'isGift',
                options: true,
            }, {
                label: 'Invoice ID',
                propKey: 'invoiceId',
            }, {
                label: 'Voided',
                propKey: 'isVoided',
                options: true,
            }
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{e.name}</td>
                <td>{shortHandDateTime(e.purchaseDate)}</td>
                <td>{formatCurrency(e.total)}</td>
                <td>{e.isGift ? 'Yes' : 'No'}</td>
                <td>
                    <LinkTo
                        target='_blank'
                        to={'/reporting/sales/transaction/' + e.transRecordId}>{e.transRecordId}</LinkTo>
                </td>
                <td>{e.isVoided ? 'Yes' : 'No'}</td>

            </tr>
        )
    }

    return <Table config={tableConfig} />;
}

export default Purchases;
